import React, { PureComponent } from 'react';

import './Errors.css';
import PageErrorX from './PageErrorX';

class PageError403 extends PureComponent {
  render() {
    return (
      <PageErrorX
        variant="403"
        title="Oops! Access Forbiden"
        message="Lo sentimos, no tienes permitido el acceso a la página solicitada. Tal vez llegaste aquí por error."
      />
    )
  }
}

export default PageError403;